// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__PL0HZ","empty":"ModalGraph_empty__3iAwm"};